/* global API, LANG */

import loadSelect2 from '../helpers/loadSelect2';

const $select = $('.js-color-select');
const $selectPrice = $('.js-color-price');
const $selectPriceWhite = $('.js-color-white');
const $selectPriceDark = $('.js-color-dark');
const $selectDefault = $('.js-select-default');

const colorSelect = {
  initialize() {
    if ($select.length) {
      loadSelect2(() => {
        this.createEvents();
      });
    }
  },

  createEvents() {
    $select.select2({
      language: {
        inputTooShort: () => LANG.select2.to_short,
        noResults: () => LANG.select2.no_result,
      },
      minimumInputLength: 3,
      ajax: {
        url: API.color,
        dataType: 'json',
        delay: 250,
        data: (params) => ({
          q: params.term,
        }),
        processResults: (data) => ({
          results: data,
        }),
      },
      templateResult: this.showResults,
      templateSelection: this.showSelection,
    });

    $select.on('select2:select', (e) => {
      const attributes = e.params.data;

      if (attributes.is_dark) {
        $selectPriceWhite.hide();
        $selectPriceDark.show();
      } else {
        $selectPriceWhite.show();
        $selectPriceDark.hide();
      }

      $selectPrice.show();
      $selectDefault.show();
    });

    $selectDefault.on('click', () => {
      this.setDefault();
    });
  },

  showResults(data) {
    if (data.loading) {
      return data.title;
    }

    return $(`
      <span data-test="test" class="select2__color" style="background-color:${data.hex}"></span>
      <span class="select2__color-text">${data.title}</span>
    `);
  },

  showSelection(data) {
    if (data.id === '') {
      return LANG.select2.default;
    }

    return $(`
      <span class="select2__color" style="background-color:${data.hex}"></span>
      <span class="select2__color-text">${data.title || data.text}</span>
    `);
  },

  setDefault() {
    $select.val($select.data('default-id')).trigger('change');
    $selectPrice.hide();
    $selectPriceWhite.hide();
    $selectPriceDark.hide();
    $selectDefault.hide();
  },
};

export default colorSelect;
